import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import PlusIcon from "app/components/Icons/PlusIcon";
import { ChevronRightIcon } from "lucide-react";
import React from "react";
import HiddenGroupItem from "../ColumnComponents/HiddenGroups/HiddenGroupItem";
import { GroupAction, GroupByTypeEnum } from "../../../../types";
import { menuItemStyles } from ".";
import clsx from "clsx";
import { formatLabel } from "../../../../helpers";
import { TicketGroup } from "../../../Tickets/types";

interface Props {
  hiddenGroups: TicketGroup[];
  groupBy: GroupByTypeEnum;
  onAction: (val: GroupAction,group) => void;
}
export default function HiddenGroupsSubMenu({
  hiddenGroups,
  groupBy,
  onAction,
}: Props) {
  if (!hiddenGroups?.length) return null;

  return (
    <DropdownMenu.Sub>
      <DropdownMenu.SubTrigger className={menuItemStyles}>
        <PlusIcon size={20} />
        Add hidden group(s)
        <ChevronRightIcon className="ml-auto size-4" />
      </DropdownMenu.SubTrigger>

      <DropdownMenu.Portal>
        <DropdownMenu.SubContent className="min-w-[200px] bg-white rounded shadow-md py-2">
          <div className="flex flex-col items-start justify-start px-4 py-3">
            <span className="text-secondary text-sm font-medium">
              Hidden group(s)
            </span>
            <span className="text-[10px] font-normal text-secondary leading-[13px]">
              {`By clicking on ${formatLabel(
                groupBy,
              )} it will be returned to the board`}
            </span>
          </div>
          <div className=" max-h-[200px] overflow-auto">
            {" "}
            {hiddenGroups.map((g) => (
              <DropdownMenu.Item
                key={g._id}
                onClick={() => onAction(GroupAction.UN_HIDE,g)}
                className={clsx(menuItemStyles)}
              >
                <HiddenGroupItem group={g} groupBy={groupBy} />
              </DropdownMenu.Item>
            ))}
          </div>
        </DropdownMenu.SubContent>
      </DropdownMenu.Portal>
    </DropdownMenu.Sub>
  );
}
